
const loginInt = {
    loginDetails: {},
    applicationDetails: {},
    currentTabDetails: '',
    tabdetails:{},
    casteDetails:{}

}

function LoginReducer(state = loginInt, action) {
    switch (action.type) {
        case "SHOW_LOGIN_DETAILS":
            return {
                ...state, 
                isLoggedIn: true,
                loginDetails: action.payload,   
            }
        case "SHOW_APPLICATION_DETAILS":
            return { ...state, applicationDetails: action.payload };
        case "SHOW_CASTE_DETAILS":
                return { ...state, casteDetails: action.payload };
        case "SHOW_TAB_DETAILS":
            return { ...state, tabdetails: action.payload };
          case "USER_LOGOUT":
            return {
              ...state,
              isLoggedIn: false,
              loginDetails:[]
             
            };

        default:
            return state;

    }
}
export default LoginReducer;
